import MuiPopover from '@mui/material/Popover';
import { FC } from 'react';
import { PopoverProps } from 'modules/mui/types';

export const BarePopover: FC<PopoverProps> = ({ children, ...props }) => {
  return <MuiPopover {...props}>{children}</MuiPopover>;
};
